import { Injectable, Signal, computed, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private loading = signal(false); // ✅ Utilizando Signal

  constructor() {}

  open = () => this.loading.set(true);

  close = () => this.loading.set(false);

  listen = (): Signal<boolean> => computed(() => this.loading()); // ✅ Expondo como Signal
}
